module.exports = __webpack_public_path__ + "static/media/phone_left_pick.295609f7.png";